/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BannerTranslationResponseDto } from './bannerTranslationResponseDto';

export interface BannerResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  name: string;
  translations: Array<BannerTranslationResponseDto>;
  /**
   * 2021-10-01T00:00:00Z
   */
  startAt: string;
  /**
   * 2021-10-01T00:00:00Z
   */
  endAt: string;
  position: BannerResponseDto.PositionEnum;
  isActive: boolean;
  imageUrl: string;
}
// tslint:disable-next-line:no-namespace
export namespace BannerResponseDto {
  export type PositionEnum = 'tablet_wallpaper' | 'admin_wallpaper';
  export const PositionEnum = {
      TabletWallpaper: 'tablet_wallpaper' as PositionEnum,
      AdminWallpaper: 'admin_wallpaper' as PositionEnum,
  };
}
